import store from '@/store/store';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

class ComunicadoAcidenteTrabalhoController {
  public static async getComunicadoAcidenteTrabalho(): Promise<any[]> {
    const route = 'getComunicadoAcidenteTrabalho';
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;
    const nrestruturam = store.state.estruturaGerencialAtual && store.state.estruturaGerencialAtual.NRESTRUTURAM 
    ? store.state.estruturaGerencialAtual.NRESTRUTURAM 
    : null;

    const params = {
      requestType  : 'FilterData',
      NRORG        : nrOrg,
      CDOPERADOR   : cdOperador,
      NRESTRUTURAM : nrestruturam,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);
      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Comunicados de Acidente de Trabalho!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getFonteGeradora(): Promise<any[]> {
    const route = 'getFonteGeradora';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Fonte Geradora';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getClassificacaoOcorrencia(): Promise<any[]> {
    const route = 'getClassificacaoOcorrencia';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Classificações da Ocorrência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }


  public static async getInfluenciaGeral(): Promise<any[]> {
    const route = 'getInfluenciaGeral';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Influência Gerencial';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getGravidadeOcorrencia(): Promise<any[]> {
    const route = 'getGravidadeOcorrencia';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Gravidades da Ocorrência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getAgenteCausadorAcidTrab(): Promise<any[]> {
    const route = 'getAgenteCausadorAcidTrab';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Agentes Causadores do Acidente de Trabalho';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getEstruturaGerencialCat(): Promise<any[]> {
    const route = 'getEstruturaGerencialCat';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Estruturas Gerenciais da CAT';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getVitima(): Promise<any[]> {
    const route = 'getVitima';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getNaturezaOcorrencia(): Promise<any[]> {
    const route = 'getNaturezaOcorrencia';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Naturezas da Ocorrência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoLocalCat(): Promise<any[]> {
    const route = 'getTipoLocalCat';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Local da cat';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getAgenteCausador(): Promise<any[]> {
    const route = 'getAgenteCausador';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Agentes Causadores';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getParteAtingida(): Promise<any[]> {
    const route = 'getParteAtingida';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Partes Atingidas';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  

  public static async getMedico(): Promise<any[]> {
    const route = 'getMedico';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Médicos';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getVinculo(): Promise<any[]> {
    const route = 'getVinculo';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Vínculos';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getNaturezaExame(): Promise<any[]> {
    const route = 'getNaturezaExame';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar as Naturezas do Exame';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getUnidadeAtendimento(): Promise<any[]> {
    const route = 'getUnidadeAtendimento';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getMotivoAusencia(): Promise<any[]> {
    const route = 'getMotivoAusencia';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getQueixa(): Promise<any[]> {
    const route = 'getQueixa';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getResultadoExame(): Promise<any[]> {
    const route = 'getResultadoExame';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getControleapt(): Promise<any[]> {
    const route = 'getControleapt';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSituacao(): Promise<any[]> {
    const route = 'getSituacao';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getProximaSituacao(): Promise<any[]> {
    const route = 'getProximaSituacao';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os Tipos de Transferência';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getCID(): Promise<any[]> {
    const route = 'getCID';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data; 
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os CIDS';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async setComunicadoAcidenteTrabalho(
    row: any,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const route = 'setComunicadoAcidenteTrabalho';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        CDOPERADOR: cdOperador,
      },
    };


    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const data: any = response.data.dataset.data;

    return data;
  }

  public static async deleteComunicadoAcidenteTrabalho(
    row: any,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;
    const route = 'deleteComunicadoAcidenteTrabalho';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        CDOPERADOR: cdOperador,
      },
    };


    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const data: any = response.data.dataset.data;

    return data;
  }

  public static async transmissaoEsocial(
    row: any,
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;
    const route = 'setEnvioEsocialCAT';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        ...row,
        CDOPERADOR: cdOperador,
        NMEVENTO: "S-2210",
      },
    };


    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);
    const data: any = response.data.dataset.data;

    return data;
  }

  

  
}

export default ComunicadoAcidenteTrabalhoController;
